/*LIBRARY*/
import { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { set_value_project } from "../../App/actions/projectActions";

/*ASSET*/
import ICON_PLUS from "../../Assets/jsx/ICON_PLUS";
import ICON_BOX from "../../Assets/jsx/ICON_BOX";
import ICON_LIST from "../../Assets/jsx/ICON_LIST";
import ICON_ARROW_DOWN from "../../Assets/jsx/ICON_ARROW_DOWN";
import ICON_ARROW_UP from "../../Assets/jsx/ICON_ARROW_UP";
import ICON_EXPAND from "../../Assets/jsx/ICON_EXPAND";

/*FUNCTION*/
import sort_array from "../../App/validation/sort_array";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

// eslint-disable-next-line camelcase
const PROJECT_CONTROL_PANEL = ({
  auth,
  project,
  set_value_project: set_value_project_action,
  toggle_create_project,
  toggle_create_folder,
}) => {
  const [modal_menu, set_modal_menu] = useState(false);
  const [anchor, set_anchor] = useState("");

  const on_change_localstorage = (name, value) => {
    set_modal_menu(false);
    localStorage.setItem(name, value);
    // eslint-disable-next-line camelcase
    const is_sort_from_small = project.is_sort_from_small;
    set_value_project_action({ key: name, value });

    if (name === "mode_sort") {
      let {
        // eslint-disable-next-line camelcase
        geo_project_list,
        // eslint-disable-next-line camelcase
        geo_project_list_child,
        // eslint-disable-next-line camelcase
        folder_project_list,
        // eslint-disable-next-line camelcase
        folder_project_child_list,
        // eslint-disable-next-line camelcase
        folder_object_selected_list,
      } = project;
      /*
      folder
      
      name - name
      date_created - date_created
      date_modified - date

      project

      name - name
      date_created - date_created
      date_modified - date_modified
      */
      // eslint-disable-next-line camelcase
      let key_project = value;
      // eslint-disable-next-line camelcase
      let key_folder = value;
      if (value === "date_modified") {
        key_project = "date";
      }

      // eslint-disable-next-line camelcase
      if (folder_object_selected_list.length === 0) {
        // eslint-disable-next-line camelcase
        geo_project_list = sort_array(
          geo_project_list,
          key_project,
          is_sort_from_small,
        );
        // eslint-disable-next-line camelcase
        folder_project_list = sort_array(
          folder_project_list,
          key_folder,
          is_sort_from_small,
        );
        set_value_project_action({
          key: "geo_project_list",
          value: geo_project_list,
        });
        set_value_project_action({
          key: "folder_project_list",
          value: folder_project_list,
        });
      } else {
        // eslint-disable-next-line camelcase
        geo_project_list_child = sort_array(
          geo_project_list_child,
          key_project,
          is_sort_from_small,
        );
        // eslint-disable-next-line camelcase
        folder_project_child_list = sort_array(
          folder_project_child_list,
          key_folder,
          is_sort_from_small,
        );
        set_value_project_action({
          key: "geo_project_list_child",
          value: geo_project_list_child,
        });
        set_value_project_action({
          key: "folder_project_child_list",
          value: folder_project_child_list,
        });
      }
    }
  };

  const toggle_localstorage = (name) => {
    const value = project[name];
    // eslint-disable-next-line camelcase
    const new_value = !value;
    localStorage.setItem(name, new_value);
    set_value_project_action({ key: name, value: new_value });
    // eslint-disable-next-line camelcase
    const mode_sort = localStorage.getItem("mode_sort")
      ? localStorage.getItem("mode_sort")
      : "date_created";
    on_change_localstorage("mode_sort", mode_sort);
  };

  const toggle_menu = (event) => {
    if (event) {
      set_modal_menu(true);
      set_anchor(event?.currentTarget);
    } else {
      set_modal_menu(false);
      set_anchor("");
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;
  // eslint-disable-next-line camelcase
  const mode_view = localStorage.getItem("mode_view")
    ? localStorage.getItem("mode_view")
    : "box"; //box || list
  // eslint-disable-next-line camelcase
  const mode_sort = localStorage.getItem("mode_sort")
    ? localStorage.getItem("mode_sort")
    : "date_modified"; //name || date_created || date_modified

  //global props
  // eslint-disable-next-line camelcase
  const is_sort_from_small = project.is_sort_from_small;

  //content

  // eslint-disable-next-line camelcase
  const mode_sort_list = [
    {
      key: "name",
      name: dict?.["Name"]?.[language],
    },
    {
      key: "date_created",
      name: dict?.["Date created"]?.[language],
    },
    {
      key: "date_modified",
      name: dict?.["Date modified"]?.[language],
    },
  ];

  // eslint-disable-next-line camelcase
  const mode_sort_name = mode_sort_list.find(
    (item) => item.key === mode_sort,
  )?.name;

  // eslint-disable-next-line camelcase
  const modal_menu_content = modal_menu && (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_menu}
      onClose={() => toggle_menu(null)}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      style={{ borderRadius: "15px" }}
    >
      <div>
        {mode_sort_list.map((item, idx) => {
          const isLast = idx === mode_sort_list.length - 1;
          return (
            <div key={idx}>
              <button
                type="button"
                onClick={() => on_change_localstorage("mode_sort", item.key)}
                className={`button_big ${!isLast ? "margin_bottom" : ""} ${
                  mode_sort === item.key ? "background_black" : "button_white"
                }`}
                data-mapid={`clickSelect-${idx}`}
              >
                {item?.name}
              </button>
              <br />
            </div>
          );
        })}
      </div>
    </FLOAT_MENU>
  );

  return (
    <main>
      {modal_menu_content}
      <table className="full_width">
        <tbody>
          <tr>
            <td className="text_left" style={{ verticalAlign: "top" }}>
              <main className="margin_bottom">
                <button
                  type="button"
                  onClick={toggle_create_project}
                  className="button_pill background_white margin_bottom margin_right"
                  data-mapid="clickNewProject"
                >
                  <span className="badge_circle background_black">
                    <ICON_PLUS />
                  </span>{" "}
                  {dict?.["New Project"]?.[language]}
                </button>
                <button
                  type="button"
                  onClick={toggle_create_folder}
                  className="button_pill background_white margin_bottom margin_right"
                  data-mapid="clickNewFolder"
                >
                  <span className="badge_circle background_black">
                    <ICON_PLUS />
                  </span>{" "}
                  {dict?.["New Folder"]?.[language]}
                </button>
                <a
                  href={`https://publication.mapid.io/login?token=${localStorage.getItem(
                    "token_mapid",
                  )}&origin=${window.location.hostname}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button_pill background_white margin_bottom margin_right"
                >
                  <span className="badge_circle background_black">
                    <ICON_PLUS />
                  </span>{" "}
                  {dict?.["Publication"]?.[language]}
                </a>
              </main>
            </td>
            <td className="text_right">
              <button
                type="button"
                className={`button margin_bottom margin_right ${
                  mode_view === "box" ? "background_black" : "background_white"
                }`}
                onClick={() => on_change_localstorage("mode_view", "box")}
              >
                <ICON_BOX
                  className={
                    mode_view === "box"
                      ? "background_black"
                      : "background_white"
                  }
                />
              </button>
              <button
                type="button"
                className={`button margin_bottom margin_right ${
                  mode_view === "list" ? "background_black" : "background_white"
                }`}
                onClick={() => on_change_localstorage("mode_view", "list")}
              >
                <ICON_LIST
                  className={
                    mode_view === "list"
                      ? "background_black"
                      : "background_white"
                  }
                />
              </button>
              <br />
              <div className="button_pill background_white margin_bottom margin_right">
                <table className="full_width" style={{ minWidth: "160px" }}>
                  <tbody>
                    <tr>
                      <td className="text_left">
                        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
                        <span
                          className="badge_circle background_grey margin_right"
                          onClick={() =>
                            toggle_localstorage("is_sort_from_small")
                          }
                          data-mapid="clickShortArrow"
                        >
                          {!is_sort_from_small ? (
                            <ICON_ARROW_DOWN />
                          ) : (
                            <ICON_ARROW_UP />
                          )}
                        </span>
                      </td>
                      <td className="text_right">
                        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
                        <div
                          onClick={toggle_menu}
                          className="inline_center"
                          data-mapid="clickShort"
                        >
                          {mode_sort_name} <ICON_EXPAND />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, {
  set_value_project,
})(PROJECT_CONTROL_PANEL);
